import React, {useEffect, useState} from 'react';
import FormInput from "../../components/form_elements/form-input";
import {Column, Row, Grid } from 'carbon-components-react';
import { useFormContext } from 'react-hook-form';
import FormDatePicker from '../../components/form_elements/form-date-picker';
import { format, parseISO } from 'date-fns';
import FormDropdown from '../../components/form_elements/form-dropdown';
import { useSelector } from "react-redux";
import { EnrollmentType } from '../../components/enums/enrollment-type';
import useMsalApi from '../../components/use-msal-api';

const EmployeeForm = ({employee, show}) => {
    const {setValue, watch} = useFormContext();
    const [maritalStatuses, setMaritialStatuses] = useState([]);
    const [genders, setGenders] = useState([]);
    const [countries, setCountries] = useState();
    const birthdate = employee?.birthdate ? parseISO(employee?.birthdate): null;
    const enrollments = useSelector(s => s.enrollments);
    const [callApi] = useMsalApi();
    const country = watch("country");

    const states = [{"name":"Alabama","abbreviation":"AL"},{"name":"Alaska","abbreviation":"AK"},{"name":"Arizona","abbreviation":"AZ"},{"name":"Arkansas","abbreviation":"AR"},{"name":"California","abbreviation":"CA"},{"name":"Colorado","abbreviation":"CO"},{"name":"Connecticut","abbreviation":"CT"},{"name":"Delaware","abbreviation":"DE"},{"name":"District Of Columbia","abbreviation":"DC"},{"name":"Florida","abbreviation":"FL"},{"name":"Georgia","abbreviation":"GA"},{"name":"Hawaii","abbreviation":"HI"},{"name":"Idaho","abbreviation":"ID"},{"name":"Illinois","abbreviation":"IL"},{"name":"Indiana","abbreviation":"IN"},{"name":"Iowa","abbreviation":"IA"},{"name":"Kansas","abbreviation":"KS"},{"name":"Kentucky","abbreviation":"KY"},{"name":"Louisiana","abbreviation":"LA"},{"name":"Maine","abbreviation":"ME"},{"name":"Maryland","abbreviation":"MD"},{"name":"Massachusetts","abbreviation":"MA"},{"name":"Michigan","abbreviation":"MI"},{"name":"Minnesota","abbreviation":"MN"},{"name":"Mississippi","abbreviation":"MS"},{"name":"Missouri","abbreviation":"MO"},{"name":"Montana","abbreviation":"MT"},{"name":"Nebraska","abbreviation":"NE"},{"name":"Nevada","abbreviation":"NV"},{"name":"New Hampshire","abbreviation":"NH"},{"name":"New Jersey","abbreviation":"NJ"},{"name":"New Mexico","abbreviation":"NM"},{"name":"New York","abbreviation":"NY"},{"name":"North Carolina","abbreviation":"NC"},{"name":"North Dakota","abbreviation":"ND"},{"name":"Ohio","abbreviation":"OH"},{"name":"Oklahoma","abbreviation":"OK"},{"name":"Oregon","abbreviation":"OR"},{"name":"Pennsylvania","abbreviation":"PA"},{"name":"Rhode Island","abbreviation":"RI"},{"name":"South Carolina","abbreviation":"SC"},{"name":"South Dakota","abbreviation":"SD"},{"name":"Tennessee","abbreviation":"TN"},{"name":"Texas","abbreviation":"TX"},{"name":"Utah","abbreviation":"UT"},{"name":"Vermont","abbreviation":"VT"},{"name":"Virginia","abbreviation":"VA"},{"name":"Washington","abbreviation":"WA"},{"name":"West Virginia","abbreviation":"WV"},{"name":"Wisconsin","abbreviation":"WI"},{"name":"Wyoming","abbreviation":"WY"}]

    useEffect(() => {
        if(!show)
            return;

        setValue("firstName", employee?.firstName);
        setValue("lastName", employee?.lastName);
        setValue("ssn", employee?.ssn);
        setValue("birthdate", birthdate);
        setValue("maritalStatusId", employee?.maritalStatus?.id);
        setValue("genderId", employee?.gender?.id);
        setValue("addressLine1", employee?.addressLine1);
        setValue("addressLine2", employee?.addressLine2);
        setValue("city", employee?.city);
        setValue("state", employee?.state);
        setValue("region", employee?.region);
        setValue("postalCode", employee?.postalCode);
        setValue("country", employee?.country);
        setMaritialStatuses(enrollments?.maritalStatuses);
        setGenders(enrollments?.genders);

    }, [show])

    useEffect(() => {
        getCountries();
    }, [])

    const getCountries = async () => {
        const results = await callApi("Lookup/Countries", "GET");
        if(!results.error){
            setCountries(results);
        }
    }

    return ( 
        <Grid narrow className='mb-20'>
            <Row>
                <Column>
                    <FormInput name="firstName" label="Legal First name" disabled={enrollments?.enrollmentTypeId !== EnrollmentType.NewHire} props={{ maxLength: "25" }}  />
                </Column>
                <Column>
                    <FormInput name="lastName" label="Legal Last name" disabled={enrollments?.enrollmentTypeId !== EnrollmentType.NewHire} props={{ maxLength: "25" }}  />
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormDatePicker name="birthdate" label="Date of Birth" disabled={enrollments?.enrollmentTypeId !== EnrollmentType.NewHire}  minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 100)).toLocaleDateString()} maxDate={new Date().toLocaleDateString()} />
                </Column>
                <Column>
                    <FormInput name="ssn" type="ssn" label="Socal security number" disabled={enrollments?.enrollmentTypeId !== EnrollmentType.NewHire} />
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormDropdown label="Marital Status" name="maritalStatusId" items={maritalStatuses} />
                </Column>
                <Column>
                    <FormDropdown label="Gender" name="genderId" items={genders} />
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormDropdown label="Country"  name="country" items={countries} disabled={enrollments?.enrollmentTypeId == EnrollmentType.LifeEvent || enrollments?.enrollmentTypeId == EnrollmentType.OpenEnrollment}/>
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormInput name="addressLine1" label="Address Line 1" props={{ maxLength: "40" }} disabled={enrollments?.enrollmentTypeId == EnrollmentType.LifeEvent || enrollments?.enrollmentTypeId == EnrollmentType.OpenEnrollment} />
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormInput name="addressLine2" label="Address Line 2" props={{ maxLength: "40" }} disabled={enrollments?.enrollmentTypeId == EnrollmentType.LifeEvent || enrollments?.enrollmentTypeId == EnrollmentType.OpenEnrollment} />
                </Column>
            </Row>
            <Row>
                <Column>
                    <FormInput name="city" label="City" props={{ maxLength: "25" }} disabled={enrollments?.enrollmentTypeId == EnrollmentType.LifeEvent || enrollments?.enrollmentTypeId == EnrollmentType.OpenEnrollment} />
                </Column>
                <Column>
                {country === "US"?
                    <FormDropdown itemValueField="abbreviation" itemTextField="abbreviation" label="State" name="state" items={states} disabled={enrollments?.enrollmentTypeId == EnrollmentType.LifeEvent || enrollments?.enrollmentTypeId == EnrollmentType.OpenEnrollment} />
                    :
                    <FormInput name="region" label="Region/State/Province" disabled={enrollments?.enrollmentTypeId == EnrollmentType.LifeEvent || enrollments?.enrollmentTypeId == EnrollmentType.OpenEnrollment} />
                }
                </Column>
                <Column>
                    <FormInput name="postalCode" label="Zip" disabled={enrollments?.enrollmentTypeId == EnrollmentType.LifeEvent || enrollments?.enrollmentTypeId == EnrollmentType.OpenEnrollment} />
                </Column>
            </Row>

        </Grid>

    );
}
 
export default EmployeeForm;